import { useNamedPresets } from '@/hooks/useNamedPresets'
import { parseScreenerOrderbookPrefs, type ScreenerOrderbookPrefs } from '@/lib/screenerOrderbookPreferences'
import type { User } from '@/types'

function normalize(value: unknown): ScreenerOrderbookPrefs | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  const item = value as Record<string, unknown>
  if (!Array.isArray(item.selectedSourceIds) || !Array.isArray(item.collapsedSourceIds)
    || !item.compression || !item.compressionOverrides) return null
  return parseScreenerOrderbookPrefs(JSON.stringify(item))
}

export function useScreenerOrderbookPresets(user: User | null, value: ScreenerOrderbookPrefs,
  onApply: (value: ScreenerOrderbookPrefs) => void, hydrated: boolean) {
  return useNamedPresets({
    user, preferenceKey: 'screener_orderbook_presets', value, onApply, normalize, disabled: !hydrated,
  })
}
